var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"loginSuccess"},[_vm._v(" 登录成功 ")])])
}]

export { render, staticRenderFns }